module.exports = __webpack_public_path__ + "img/canvasMenu3.cef6d28e.svg";